import {健康保険被保険者区分, 社会保険定数} from "./types"

export function calculate月間子育て支援金(
  標準報酬月額: number,
  健康保険被保険者区分: 健康保険被保険者区分,
  _年齢: number,
  対象年: number,
): number {
  // 2026年度以降に適用
  if (対象年 < 社会保険定数.子育て支援金.開始年) return 0;

  // いったんError
  if (健康保険被保険者区分 === "国民健康保険") return 0;

  const 子育て支援金率 = 0.023;
  const 月間子育て支援金: number = (標準報酬月額 * 子育て支援金率) / 2;
   
  return 月間子育て支援金;
}
